import React, { useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '../../supabase';

function Login() {

    const [error, setError] = useState(null)

    let Navigate = useNavigate()

    let email = useRef();
    let password = useRef()

    let login = async () => {

        let authData = {
            email: email.current.value,
            password: password.current.value
        }

        const { data, error } = await supabase.auth.signInWithPassword(authData)

        console.log(data);
        console.log(error, "error");

        if (error) setError(error.message)
        else Navigate('/dashboard')

    }


    return (
        <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
            data-sidebar-position="fixed" data-header-position="fixed">
            <div
                class="position-relative overflow-hidden text-bg-light min-vh-100 d-flex align-items-center justify-content-center">
                <div class="d-flex align-items-center justify-content-center w-100">
                    <div class="row justify-content-center w-100">
                        <div class="col-md-8 col-lg-6 col-xxl-3">
                            <div class="card mb-0">
                                <div class="card-body">
                                    <h2 class="text-center text-dark fw-bold">Rkivedocs</h2>
                                    <form>
                                        <div class="mb-3">
                                            <label for="exampleInputEmail1" class="form-label">Username</label>
                                            <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" ref={email} />
                                        </div>
                                        <div class="mb-4">
                                            <label for="exampleInputPassword1" class="form-label">Password</label>
                                            <input type="password" class="form-control" id="exampleInputPassword1" ref={password} />
                                        </div>

                                        <Link class="btn  w-100 py-8 fs-4 mb-4 rounded-2 bg-dark text-white" onClick={login}>Sign In</Link>
                                        <div class="d-flex align-items-center justify-content-center ">
                                            <p class=" mb-0 ">Not Login?</p>
                                            <Link to={'/register'} class="text-dark fw-bold ms-2" >Create an account</Link>
                                        </div>
                                    </form>
                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>


    )
}

export default Login